<ion-header>
  <ion-toolbar>
    <ion-title>Create User</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <form [formGroup]="form">
      <ion-item>
        <ion-input label="{{'First name' | translate}}" labelPlacement="floating" type="text" formControlName="first_name"></ion-input>
      </ion-item>
      <ion-item>
        <ion-input label="{{'Last name' | translate}}" labelPlacement="floating" type="text" formControlName="last_name"></ion-input>
      </ion-item>
    </form>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button (click)="submit()" expand="block">
      {{'Submit' | translate}}
    </ion-button>
  </ion-toolbar>
</ion-footer>